import { render, staticRenderFns } from "./SimpleConfirmationDialog.vue?vue&type=template&id=0133d4b4&"
import script from "./SimpleConfirmationDialog.vue?vue&type=script&lang=ts&"
export * from "./SimpleConfirmationDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports